import { PlusIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';
import { useUserContext } from '../../providers/UserProvider';
import { useUserFirms } from '../../queries/use-user-firms';
import FirmSelectFirmName from './FirmSelectFirmName';

type FirmSelectDropdownProps = {
    firmId: string;
};

function FirmSelectDropdown({ firmId }: FirmSelectDropdownProps): JSX.Element {
    const { id: userId } = useUserContext();
    const { isExternalUser } = useIsFirmRole();
    const userFirmsQuery = useUserFirms(userId);

    return (
        <>
            <div className="dark:text-white/[0.60] rounded-lg text-gray-700 grid items-center w-[400px] text-sm p-2 max-h-[450px] border-b overflow-y-auto">
                {(userFirmsQuery.data?.firms || [])
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .sort((a) => (a.id === firmId ? -1 : 1))
                    .map((firm, idx) => {
                        return <FirmSelectFirmName firm={firm} key={idx} current={firm.id === firmId} />;
                    })}
            </div>
            {!isExternalUser && (
                <Link to="../onboarding?step=create-firm">
                    <button className="flex gap-2 items-center py-3 pl-3">
                        <PlusIcon className="w-5 h-5" />
                        <p className="text-gray-900 text-sm">New Firm</p>
                    </button>
                </Link>
            )}
        </>
    );
}

export default FirmSelectDropdown;
